import type { CityConfig } from "../city-template/types";

export const desPlainesConfig: CityConfig = {
  city: "Des Plaines",
  state: "Illinois",
  stateAbbr: "IL",
  slug: "des-plaines",
  route: "/cities/des-plaines",
  title: "Emergency Passport Des Plaines IL | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Des Plaines, Illinois — as fast as 24 hours. Fast passport renewal and new passport applications near O'Hare International Airport. A+ BBB rated registered State Dept. courier serving Northwest Cook County.",
  h1: "Emergency & Expedited Passport Services in Des Plaines, IL",
  heroSubtitle: "Rivers Casino conference in Toronto next week and your passport expired? Business trip out of O'Hare with 4 days notice? Family vacation to Cancun leaving Friday? We help Des Plaines residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier serving Northwest Cook County and the O'Hare corridor.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Des%20Plaines%20Illinois%20scenic%20city%20view%20featuring%20the%20Des%20Plaines%20River%20with%20tree%20lined%20riverfront%2C%20historic%20downtown%20district%20with%20charming%20storefronts%2C%20the%20iconic%20Chicago%20area%20water%20tower%2C%20suburban%20parks%20and%20green%20spaces%2C%20peaceful%20northwest%20Cook%20County%20atmosphere%20with%20mature%20trees%20and%20community%20feel%2C%20golden%20hour%20warm%20light%2C%20professional%20photography%2C%20Illinois%20suburban%20landscape&width=1800&height=700&seq=des-plaines-hero-001&orientation=landscape",
  heroImageAlt: "Des Plaines Illinois with Des Plaines River and historic downtown at golden hour",
  geoPosition: "42.0334;-87.8834",
  geoPlacename: "Des Plaines, Illinois",
  lastModified: "2026-06-04",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 W Congress Pkwy, 4th Floor, Chicago, IL 60605",
    distance: "Approximately 35 minutes southeast of Des Plaines via I-294 and I-90",
  },
  nearbyCitiesZips: [
    { name: "Des Plaines", zips: "60016, 60017, 60018, 60019" },
    { name: "Park Ridge", zips: "60068" },
    { name: "Rosemont", zips: "60018" },
    { name: "Mount Prospect", zips: "60056" },
    { name: "Arlington Heights", zips: "60004, 60005" },
    { name: "Elk Grove Village", zips: "60007" },
    { name: "Niles", zips: "60714" },
    { name: "Glenview", zips: "60025, 60026" },
    { name: "Schaumburg", zips: "60173, 60193, 60194" },
    { name: "Palatine", zips: "60067, 60074" },
    { name: "Skokie", zips: "60076, 60077" },
    { name: "Wheeling", zips: "60090" },
    { name: "Prospect Heights", zips: "60070" },
    { name: "Norridge", zips: "60706" },
    { name: "Harwood Heights", zips: "60706" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Chicago Passport Agency — 35 minutes away but you skip the trip" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-plane-line", title: "O'Hare Travel Hub", desc: "Minutes from O'Hare — ideal for last-minute international travelers in Northwest Cook" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — ship from any UPS in Des Plaines" },
  ],
  internalLinks: [
    { name: "Expedited passport in Arlington Heights, IL", route: "/cities/arlington-heights" },
    { name: "Emergency passport help in Chicago, IL", route: "/cities/chicago" },
    { name: "Urgent passport services in Schaumburg, IL", route: "/cities/schaumburg" },
    { name: "Illinois passport services overview", route: "/states/illinois" },
  ],
  fpcOfficeAddress: "101 W Congress Pkwy, 4th Floor, Chicago, IL 60605",
  fpcOfficeNote: "Fast Passport Center serves Des Plaines, Illinois remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (35 minutes southeast via I-294/I-90) — without you making the trip. Des Plaines residents can ship from any UPS or FedEx location in Northwest Cook County.",
  fpcOfficeDistance: "Serving Des Plaines, Park Ridge, Rosemont, Mount Prospect, Arlington Heights, Elk Grove Village, Niles, Glenview, Schaumburg, Palatine, Skokie, and all of Northwest Cook County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Des Plaines and Northwest Cook County. From the Des Plaines River corridor and historic downtown to the bustling commercial areas near O'Hare, from the family neighborhoods of Golf and Cumberland to the corporate offices near I-294 — we serve Des Plaines, Park Ridge, Rosemont, Mount Prospect, and the entire O'Hare region.",
  nearbyCitiesIntro: "We serve Des Plaines and all nearby communities including Park Ridge, Rosemont, Mount Prospect, Arlington Heights, Elk Grove Village, Niles, Glenview, Schaumburg, Palatine, Skokie, Wheeling, Prospect Heights, Norridge, and Harwood Heights. Minutes from O'Hare — we have Northwest Cook County covered.",
  howItWorksIntro: "Most Des Plaines travelers complete everything online and ship documents overnight. No need to drive 35 minutes to downtown Chicago — our couriers handle the Chicago Passport Agency trip for you.",
  mistakesIntro: "Des Plaines sits in the heart of the O'Hare corridor with thousands of last-minute international travelers. Here are the most common passport mistakes we see from Northwest Cook County residents.",
  testimonialsIntro: "Des Plaines travelers — from business professionals heading out of O'Hare to family vacationers in the Northwest suburbs — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Des Plaines, IL? Here are the most common ones we hear from Northwest Cook County travelers.",
  statePageRoute: "/states/illinois",
  statePageName: "Illinois",
  dmvWebsite: "https://www.ilsos.gov/facilities/facilitylist.html",
  dmvLabel: "Illinois Secretary of State — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 35 minutes to downtown Chicago", "Downtown parking, navigation, time commitment"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "No drive to downtown Chicago required", "Perfect for O'Hare travelers and business trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Des Plaines travelers with immediate departure needs — as fast as 24 hours. Our couriers use the Chicago Passport Agency — 35 minutes away but you never make the trip.",
      bullets: ["24–48 hour turnaround available", "Chicago Passport Agency direct courier", "Perfect for last-minute O'Hare departures"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Des Plaines adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Des Plaines address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Des Plaines residents — including new citizens and Northwest Cook County families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Des Plaines residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Des Plaines and Northwest Cook County families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Des Plaines and Northwest Cook County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Des Plaines IL", description: "Urgent passport processing for Des Plaines Illinois travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Des Plaines IL", description: "Fast passport renewal for Des Plaines Illinois residents near O'Hare International Airport." },
    { name: "First-Time Passport Des Plaines IL", description: "New passport application services for Des Plaines Illinois residents." },
    { name: "Child Passport Des Plaines IL", description: "Minor passport services for Des Plaines Illinois families with children under 16." },
  ],
  testimonials: [
    {
      name: "James R.",
      location: "Des Plaines, IL",
      rating: 5,
      text: "Business trip to Tokyo out of O'Hare in 4 days and my passport was expired. Fast Passport Center had my renewal in 26 hours. I shipped from the UPS on Elmhurst Road and had it back before my Wednesday flight. Absolutely incredible for O'Hare travelers.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Linda M.",
      location: "Mount Prospect, IL",
      rating: 5,
      text: "Family vacation to Italy leaving in 8 days and my husband's passport had 2 months left before expiration. Fast Passport Center explained the 6-month rule many countries require and got his renewal done in 3 days. Saved our anniversary trip.",
      service: "Passport Renewal",
    },
    {
      name: "David C.",
      location: "Park Ridge, IL",
      rating: 5,
      text: "Lost my passport 3 days before flying to London for my daughter's graduation. Fast Passport Center walked me through the lost passport process and got a replacement in 30 hours. I still can't believe it. Amazing service for Northwest Cook County.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "dpl-1",
      name: "Des Plaines Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1000 E Oakton St",
      city: "Des Plaines",
      state: "IL",
      zip: "60018",
      phone: "(847) 699-2920",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "East Des Plaines, near downtown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Des Plaines acceptance facility. Appointments recommended — near downtown Des Plaines and the Des Plaines River.",
      icon: "ri-mail-line",
    },
    {
      id: "dpl-2",
      name: "Park Ridge Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "333 Busse Hwy",
      city: "Park Ridge",
      state: "IL",
      zip: "60068",
      phone: "(847) 692-3446",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Park Ridge, approximately 3 miles east of Des Plaines",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Park Ridge and eastern Des Plaines. Near Uptown Park Ridge shopping district.",
      icon: "ri-mail-line",
    },
    {
      id: "dpl-3",
      name: "Mount Prospect Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "125 E Central Rd",
      city: "Mount Prospect",
      state: "IL",
      zip: "60056",
      phone: "(847) 255-7150",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Mount Prospect, approximately 5 miles north of Des Plaines",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Mount Prospect and northern Des Plaines. Near downtown Mount Prospect.",
      icon: "ri-mail-line",
    },
    {
      id: "dpl-4",
      name: "Elk Grove Village Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "901 Elk Grove Town Center",
      city: "Elk Grove Village",
      state: "IL",
      zip: "60007",
      phone: "(847) 439-3111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Elk Grove Village, approximately 7 miles west of Des Plaines",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Elk Grove Village and western Des Plaines area. Near town center.",
      icon: "ri-mail-line",
    },
    {
      id: "dpl-5",
      name: "Cook County Clerk — Rolling Meadows",
      type: "County Clerk Passport Acceptance",
      address: "2121 Euclid Ave, Room 238",
      city: "Rolling Meadows",
      state: "IL",
      zip: "60008",
      phone: "(312) 603-5656",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Rolling Meadows, approximately 8 miles northwest of Des Plaines",
      website: "https://www.cookcountyclerk.com/",
      websiteLabel: "Cook County Clerk",
      notes: "Cook County Clerk satellite passport acceptance. Serves Northwest Cook County. Call ahead to confirm hours.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 35 min drive to downtown Chicago", fpc: "No — ship from Des Plaines" },
    { feature: "Parking & Navigation", agency: "Downtown Chicago parking costs", fpc: "Ship from your neighborhood" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-calendar-close-line",
      title: "Last-Minute O'Hare Departures",
      description: "Living minutes from O'Hare means Des Plaines residents are often spontaneous international travelers. Many discover expired or expiring passports just days before departure. The Chicago Passport Agency is close but appointments fill weeks out.",
    },
    {
      icon: "ri-passport-line",
      title: "Six-Month Passport Validity Rule",
      description: "Many countries require your passport to be valid for at least 6 months beyond your return date. Des Plaines travelers often show up at O'Hare with passports valid for only 3 months and get denied boarding. Check entry requirements early.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size",
      description: "Local photo services in the O'Hare corridor sometimes produce photos that don't meet strict passport standards. Photos must be exactly 2x2 inches on a white background with no shadows or glare.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or incorrect form type cause rejections at Des Plaines and Mount Prospect acceptance facilities. Verify everything before your appointment — don't risk a second trip.",
    },
    {
      icon: "ri-road-map-line",
      title: "Driving to Chicago Agency Unnecessarily",
      description: "Des Plaines is only 35 minutes from the Chicago Passport Agency, but downtown Chicago parking and navigation add stress and cost. Our courier service makes the trip for you — more reliable and faster.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent for Minors",
      description: "Both parents must appear or submit notarized consent for child passports. Northwest Cook County families often arrive at acceptance facilities with only one parent — causing delays and rescheduling.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Des Plaines or Northwest Cook." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx near downtown Des Plaines." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — experienced with O'Hare corridor corporate and family travel." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Chicago Passport Agency — 35 minutes away but you never make the trip." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Des Plaines address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Des Plaines, IL?", a: "Fast Passport Center offers emergency passport processing in Des Plaines, Illinois in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (35 minutes southeast via I-294/I-90) — without you making the trip. Perfect for last-minute O'Hare departures." },
    { q: "Does Des Plaines have its own passport agency?", a: "No — Des Plaines does not have a regional passport agency. The nearest facility is the Chicago Passport Agency (approximately 35 minutes southeast via I-294 and I-90). Fast Passport Center's courier service means Des Plaines and Northwest Cook County residents never need to make the trip." },
    { q: "Can I get a passport renewed near O'Hare Airport?", a: "Absolutely. Fast Passport Center serves travelers throughout the O'Hare corridor including Des Plaines, Rosemont, Park Ridge, Elk Grove Village, and Bensenville. Our service works seamlessly — ideal for last-minute business and leisure travelers departing from O'Hare." },
    { q: "What airport do Des Plaines travelers use for international flights?", a: "Chicago O'Hare International Airport (ORD) is the primary airport for Des Plaines residents — just minutes east via I-190 or River Road. O'Hare offers direct flights to every continent. This proximity makes our 24–48 hour emergency service especially valuable." },
    { q: "Do you serve Mount Prospect, Park Ridge, and Rosemont?", a: "Yes — Fast Passport Center serves all of Northwest Cook County including Mount Prospect, Park Ridge, Rosemont, Elk Grove Village, Arlington Heights, Niles, and Glenview. Our service works identically across the entire region." },
    { q: "Where can I get passport photos in Des Plaines?", a: "Walgreens, CVS, and UPS Store throughout Des Plaines and surrounding areas offer passport photos. FedEx Office near O'Hare also provides them. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Can I get my child a passport in Des Plaines?", a: "Yes. Fast Passport Center provides child passport services for minors under 16 throughout Des Plaines and Northwest Cook County. Both parents or guardians typically need to be present at the acceptance facility, and we guide you through the process." },
    { q: "How much does an expedited passport cost in Des Plaines?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for renewal. Fast Passport Center's service fees vary by processing speed. Contact us for a personalized quote based on your travel date." },
  ],
  photoLocations: [
    { name: "Walgreens — Des Plaines", address: "21 W Rand Rd, Des Plaines, IL 60016", hours: "Mon–Sun: 7AM–10PM" },
    { name: "UPS Store — Des Plaines", address: "1440 E Oakton St, Des Plaines, IL 60018", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "CVS — Mount Prospect", address: "999 E Rand Rd, Mount Prospect, IL 60056", hours: "Mon–Sun: 8AM–10PM" },
    { name: "FedEx Office — Rosemont", address: "6150 N River Rd, Rosemont, IL 60018", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    { name: "Illinois SOS — Des Plaines", address: "1470 Lee St, Des Plaines, IL 60018", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Illinois Secretary of State facility for driver's licenses, REAL ID, and vehicle registration. Convenient to downtown Des Plaines. Online reservations strongly recommended.", featured: true },
    { name: "Illinois SOS — Schaumburg", address: "1227 E Golf Rd, Schaumburg, IL 60173", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Serves Schaumburg, Elk Grove Village, and western Des Plaines area. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "Approximately 10 minutes east via I-190 or River Road",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "The primary international airport for Des Plaines — literally minutes away. One of the world's busiest airports with direct flights to Europe, Asia, South America, and Africa. United and American Airlines hub. Des Plaines residents can be at their gate in 15 minutes.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Flight Info",
      featured: true,
    },
    {
      code: "MDW",
      name: "Chicago Midway International Airport",
      distance: "Approximately 40 minutes southeast via I-294 and I-55",
      address: "5700 S Cicero Ave, Chicago, IL 60638",
      note: "Southwest Airlines hub with domestic and some international connections. Good for Des Plaines travelers who prefer Southwest Airlines.",
      flightUrl: "https://www.flychicago.com/midway/",
      flightLabel: "MDW Flight Info",
      featured: false,
    },
  ],
};